<template>
  <main>
    <v-toolbar class="blue darken-2" app fixed dark>
      <v-toolbar-side-icon @click.stop="$root.$children[0]._data.drawer = !$root.$children[0]._data.drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-if="currentDataset.meta.name">Aufwertung: {{ currentDataset.meta.name }}</v-toolbar-title>
      <v-toolbar-title v-else>Aufwertung</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>search</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content v-if="currentDataset.meta.name">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 sm4 lg3>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data"></search-datasets>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm8 lg9>
            <v-card>
              <v-toolbar dark class="cyan elevation-0">
                <v-toolbar-title class="white--text">Aufwertung</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click.native="coloriseSimilarCells" :loading="loadingColorisingCells">
                  <v-icon left>select_all</v-icon>
                  Ähnliche Zellen markieren
                </v-btn>
                <v-btn flat @click.native="mergeSimilarCells" :disabled="!colorisedSimilarCells" :loading="loadingMergingCells">
                  <v-icon left>tab_unselected</v-icon>
                  Markierte zusammenfassen
                </v-btn>
                <v-btn icon @click.native="clearFormatting" :loading="refreshingTable">
                  <v-icon>refresh</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-title primary-title>
                <div>
                  <div class="body-2 grey--text">Wählen Sie eine der Funktionen aus, um fortzufahren.</div>
                </div>
              </v-card-title>

              <v-card-text v-if="loadingDatasetIndicator" style="height: 500px;">
                <v-progress-circular indeterminate class="loading-dataset-indicator"></v-progress-circular>
              </v-card-text>

              <v-card-text v-else-if="!currentDataset.dataset.data" style="height: 500px;">
                Keine Daten
              </v-card-text>

              <v-card-text v-else>
                <Spreadsheet :root="root" :settings="currentDataset.dataset" ref="spread"></Spreadsheet>
              </v-card-text>
              <v-card-actions>
                <v-btn flat color="primary">Änderungen speichern</v-btn>
                <v-btn flat>Abbrechen</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-content v-else>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data" :show-hint="true"></search-datasets>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
          
  </main>
</template>

<script>
import Spreadsheet from 'vue-handsontable-official'
import SearchDatasets from '@/components/SearchDatasets'

export default {
  computed: {
    currentDataset () {
      return this.$store.getters.getCurrentDataset
    },
    datasetsMeta () {
      return this.$store.getters.getDatasetsMeta
    },
    loadingDatasetIndicator () {
      return this.$store.getters.getLoadingDatasetIndicator
    }
  },
  components: {
    Spreadsheet,
    SearchDatasets
  },
  data () {
    return {
      loadingColorisingCells: false,
      loadingMergingCells: false,
      colorisedSimilarCells: false,
      mergedSimilarCells: false,
      refreshingTable: false,
      root: 'test-hot'
    }
  },
  methods: {
    coloriseSimilarCells: function () {
      let table = this.$refs.spread.table
      let cells = [
        [0, 1], [1, 1], // Name
        [0, 2], [1, 2], // Bezirk
        [0, 7], [1, 7] // RSS-Name
      ]

      this.loadingColorisingCells = true
      var that = this
      setTimeout(function () {
        if (!that.mergedSimilarCells) {
          for (var i = cells.length - 1; i >= 0; i--) {
            table.getCell(cells[i][0], cells[i][1]).style.backgroundColor = 'orange'
            table.getCell(cells[i][0], cells[i][1]).style.fontWeight = 'bold'
          }
        }
        that.loadingColorisingCells = false
        that.colorisedSimilarCells = true
      }, 600)
    },
    mergeSimilarCells: function () {
      this.loadingMergingCells = true

      var that = this
      setTimeout(function () {
        that.currentDataset.dataset.data.splice(1, 1)
        that.loadingMergingCells = false
        that.mergeSimilarCells = true
        that.colorisedSimilarCells = false
        that.currentDataset.meta.status.stepAufwertung = true
      }, 600)
    },
    clearFormatting: function () {
      let table = this.$refs.spread.table

      this.refreshingTable = true
      var that = this
      setTimeout(function () {
        table.render()
        that.refreshingTable = false
      }, 400)
    }
  }
}
</script>

<style>
#test-hot {
  height: 400px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Aufwertung.vue